import "./loader.css";

export default function Loader() {
  return (
    <div id="loading-bar-spinner" className="spinner">
      <div className="spinner-icon"></div>
    </div>
  );
}
